import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';

// CONSTANTS
import { LOCATIONS_FREE_TV_LANDING_PAGE } from '@/constants/locations';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { externalLink } from '@/utility/analytics';

const rokuImg = getS3ImageUrl('/free-tv/roku-color.svg');
const androidTVImg = getS3ImageUrl('/free-tv/android-tv-color.svg');
const fireTVImg = getS3ImageUrl('/free-tv/amazon-fire-tv-color.svg');
const LGImg = getS3ImageUrl('/free-tv/lg-color.svg');
const philipsImg = getS3ImageUrl('/free-tv/phillips-color.svg');

/*
const appleTVImg = getS3ImageUrl('/free-tv/apple-tv.svg');
const samsungSTVImg = getS3ImageUrl('/free-tv/samsung-smart-tv.svg');
*/

const servicesData = [
  {
    img: rokuImg,
    title: 'Roku',
    url: 'https://channelstore.roku.com/details/a76756458cc5246f3619e8ea2f3f7f40/mybundle-free-tv',
  },
  /* { img: appleTVImg, title: 'Apple TV' }, */
  {
    img: androidTVImg,
    title: 'Android TV',
    url: 'https://play.google.com/store/apps/details?id=com.mybundle.ott.tv&pli=1',
  },
  /* { img: samsungSTVImg, title: 'Samsung smart TV' }, */
  { img: fireTVImg, title: 'Amazon Fire TV', url: 'https://www.amazon.com/dp/B0CVC6FM47/' },
  {
    img: LGImg,
    title: 'LG',
    url:
      'https://us.lgappstv.com/main/tvapp/detail?appId=1230930&catCode1=&moreYn=N&cateYn=N&orderType=0&headerName=&appRankCode=&sellrUsrNo=',
  },
  { img: philipsImg, title: 'Phillips Smart TV' },
];

function externalLinkClicked(item) {
  externalLink({
    href: item.url,
    location: LOCATIONS_FREE_TV_LANDING_PAGE,
    service_name: item.title,
    type: 'device',
  });
}

const Services = () => {
  const [t] = useTranslation();

  return (
    <div className="services section">
      <div className="page-content">
        <Typography
          className="section__title services__title"
          align="center"
          component="h3"
          variant="h5"
        >
          {t('freeTv.services.title')}
        </Typography>
        <ul className="services__list">
          {servicesData.map((item, idx) => (
            <li key={idx}>
              <a
                href={item.url}
                target="_blank"
                rel="noreferrer"
                onClick={() => externalLinkClicked(item)}
              >
                <img src={item.img} alt={item.title} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default React.memo(Services);
